/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
/**
 * follow alipay mini program https://opendocs.alipay.com/mini/00nmrr
 * 错误码规范：https://alidocs.dingtalk.com/i/nodes/jQPRqwxd3NLWjlRdOAOzJYK6lrGM4795# 「错误码定义」
 */
var ErrorCodes;
(function (ErrorCodes) {
    ErrorCodes["ErrScanUserCancel"] = "10";
    /**
     * 暂不支持的端调用。
     * 命名6位数，防止与其他环境（一般5位数）的errorCode冲突
     */
    ErrorCodes["NotSupport"] = "100099";
    /** 按需加载失败 */
    ErrorCodes["DependError"] = "100098";
})(ErrorCodes || (ErrorCodes = {}));
/** 错误文案信息 */
var ErrorMsgs;
(function (ErrorMsgs) {
    ErrorMsgs["ErrMsgCommon"] = "call failed";
    ErrorMsgs["ErrMsgCancel"] = "user cancel";
})(ErrorMsgs || (ErrorMsgs = {}));
// 按需加载
var AppxWebviewURL = 'https://appx/web-view.min.js';
var PanguMiniAppTpPlusURL = 'https://g.alicdn.com/cn-yz/tp-plus/1.0.12/tp-plus-web.js';
/** 容器依赖的jssdk */
var BRIDGE_DEPEND_LIBS = {
    dingTalk: [
        'https://g.alicdn.com/dingding/dingtalk-jsapi/2.15.5/dingtalk.internal.js',
    ],
    miniWeb: [AppxWebviewURL],
    panguMiniApp: [AppxWebviewURL, PanguMiniAppTpPlusURL],
};

export { BRIDGE_DEPEND_LIBS as B, ErrorCodes as E, ErrorMsgs as a };
